<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 28.502 26.226">
        <path id="Path_993" data-name="Path 993" d="M7437.429-12666.079l13.279-28.5a66.011,66.011,0,0,1-26.226,0C7430.067-12683.521,7437.429-12666.079,7437.429-12666.079Z" transform="translate(12694.581 7450.708) rotate(-90)" :fill="fill"/>
    </svg>
</template>

<script>
export default {
    name: 'ActionArrow',
    props: {
        fill: {
            type: String,
            required: false,
            default: '#000'
        },
        width: {
            type: String,
            default: '28.502'
        },
        height: {
            type: String,
            default: '26.226'
        }
    },
    data() {
        return {
            path: 'M7431.722-12678.641l7.426-15.939a36.938,36.938,0,0,1-14.666,0C7427.605-12688.4,7431.722-12678.641,7431.722-12678.641Z'
        }
    }
}
</script>
